import { render, staticRenderFns } from "./vsCheckboxCustom.vue?vue&type=template&id=5cd027bf"
import script from "./vsCheckboxCustom.vue?vue&type=script&lang=js"
export * from "./vsCheckboxCustom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\xampp\\htdocs\\site-teste\\flash-master\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cd027bf')) {
      api.createRecord('5cd027bf', component.options)
    } else {
      api.reload('5cd027bf', component.options)
    }
    module.hot.accept("./vsCheckboxCustom.vue?vue&type=template&id=5cd027bf", function () {
      api.rerender('5cd027bf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Resources/js/src/components/vsCheckboxCustom/vsCheckboxCustom.vue"
export default component.exports